module.exports = __webpack_public_path__ + "static/media/ReactAbout.c8ed6c0e.png";